<!-- Annotation Label Form -->
@if (annotationLabelForm) {
  <medsurf-design-form-control-form
    [formGroup]="annotationLabelForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <!-- Editor -->
    <medsurf-editor [hidden]="(slideAuthorFacade.currentSelectedSlideIsFreeForm$ | async) === false || (slideAuthorFacade.currentSelectedSlideFreeFormIsLine$ | async) === true || (slideAuthorFacade.currentSelectedSlideFreeFormIsFree$ | async) === true"
      [control]="annotationLabelForm.controls.description"
      placeholder="global.description"
      [toolbarExcludes]="['mediaimage', 'mediapdf', 'mediaaudio', 'mediavideo', 'marker']"
    (valueChange)="onSubmit()"></medsurf-editor>
  </medsurf-design-form-control-form>
}